import { CrudTable } from "@/components/shared";
import { inr } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const SERVICES = ["Rhinoplasty", "Hair Transplant", "Liposuction", "Botox", "Dermal Fillers", "Laser Skin", "Facelift", "Gynecomastia"];

const discountPct = (r) => {
  if (!r.standard_price) return 0;
  return Math.round((1 - r.quoted_price / r.standard_price) * 100);
};

export default function Pricing() {
  const columns = [
    { key: "date", label: "Date", render: (r) => r.date?.slice(0, 10) },
    { key: "patient_name", label: "Patient" },
    { key: "branch", label: "Branch" },
    { key: "service", label: "Service" },
    { key: "standard_price", label: "Standard", render: (r) => <span className="font-mono-ync">{inr(r.standard_price)}</span> },
    { key: "quoted_price", label: "Quoted", render: (r) => <span className="font-mono-ync text-[#34d399]">{inr(r.quoted_price)}</span> },
    { key: "discount", label: "Discount", render: (r) => {
      const d = discountPct(r);
      const over = !r.within_policy;
      return <span className={`font-mono-ync ${over ? "text-[#f87171]" : d > 0 ? "text-[#C9A24B]" : "text-slate-400"}`}>{d}%</span>;
    } },
    { key: "approved_by", label: "Approved By" },
    { key: "within_policy", label: "Policy", render: (r) => r.within_policy
      ? <Badge className="bg-[#059669]/15 text-[#34d399] border-0">Within</Badge>
      : <Badge className="bg-[#DC2626]/15 text-[#f87171] border-0">Beyond</Badge> },
  ];
  const fields = [
    { key: "patient_id", label: "Patient (linked)", type: "patient", full: true },
    { key: "patient_name", label: "Patient Name (or type manually)", type: "text" },
    { key: "branch", label: "Branch", type: "select", optionsKey: "branches" },
    { key: "service", label: "Service", type: "select", options: SERVICES },
    { key: "standard_price", label: "Standard Price (₹)", type: "number" },
    { key: "quoted_price", label: "Quoted Price (₹)", type: "number" },
    { key: "approved_by", label: "Approved By", type: "select", options: ["Relationship Manager", "Founder", "Branch Head"] },
    { key: "within_policy", label: "Within Discount Policy", type: "switch" },
    { key: "notes", label: "Notes", type: "textarea", full: true },
  ];
  return (
    <CrudTable
      testid="pricing" endpoint="pricing"
      title="Pricing & Discount Control"
      subtitle="Every quote vs standard price, discount given, who approved it and whether it stays within policy."
      columns={columns} fields={fields}
      defaults={{ standard_price: 0, quoted_price: 0, within_policy: true }}
    />
  );
}
